module.exports = __webpack_public_path__ + "static/media/03_workshop_video.cf249418.png";